export const getTipoAgua = (state) => state.tipoAgua.lista
export const getIsCarregandoListaTipoAgua = (state) => state.tipoAgua.isCarregandoLista
export const getIsSavingTipoAgua = (state) => state.tipoAgua.isSaving
export const getIsUpdatingTipoAgua = (state) => state.tipoAgua.isUpdate
